/**
 * Main application entry point for the Angular Symbox homepage application.
 * Bootstraps the standalone Angular application with necessary providers and services.
 *
 * @author Symbox Development Team
 * @version 1.0.0
 */

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { register } from 'swiper/element/bundle';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { routes } from './app/app-routing.module';

/**
 * Register Swiper web components globally for the application.
 * This enables the use of Swiper carousel functionality throughout the app.
 */
register();

/**
 * Enable production mode if running in production environment.
 * This optimizes the application for production by disabling development-specific features.
 */
if (environment.production) {
  enableProdMode();
}

/**
 * Bootstrap the standalone Angular application with all necessary providers.
 *
 * @remarks Initializes the Angular application with:
 * - HTTP client with legacy interceptor support
 * - Browser animations
 * - Router with scroll position restoration
 * - Angular SVG icon support
 *
 * @throws Will log error to console if bootstrap fails
 */
bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideAngularSvgIcon(),
  ],
}).catch(err => console.log(err));
